import { render } from "./PayInItem.vue?vue&type=template&id=045813af&scoped=true"
import script from "./PayInItem.vue?vue&type=script&lang=js"
export * from "./PayInItem.vue?vue&type=script&lang=js"

import "./PayInItem.vue?vue&type=style&index=0&id=045813af&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045813af"]])

export default __exports__